<template>
    <div class="container">
        <schoolAndDate :schoolName="schoolName" :dateTime="dateTime" />
        <div class="wrap">

            <div class="meal-list-wrap unified-meal" ref="content" :style="`animation-duration:${animationDuration}s`">
                <div class="meal-list" v-for="(itemPar, indexPar) in infos" :key="indexPar">
                    <div class="meal-date">{{ itemPar.endDate || '' }} {{ itemPar.startDate || '' }}</div>

                    <div class="meal-block">
                        <div class="meal-item" v-for="(listItem, listIndex) in handleInfoItemData(itemPar)"
                            :key="listIndex">
                            <div :class="listIndex === 0 ? 'meal-title' : 'meal-content'">
                                <span>{{ listItem.title || '无' }}</span>
                            </div>
                            <div :class="listIndex === 0 ? 'meal-title' : 'meal-content'">
                                <span>{{ listItem.cookBook || '无' }}</span>
                            </div>
                            <div :class="listIndex === 0 ? 'meal-title' : 'meal-content'">
                                <p v-for="(conItem, conIndex) in renderContent(listItem.oilAndSaltAndSugar)" :key="conIndex">{{ conItem }}</p>
                                <span>{{ listItem.oilAndSaltAndSugar ? '' : '无' }}</span>
                            </div>
                            <div :class="listIndex === 0 ? 'meal-title' : 'meal-content'">
                                <p v-for="(conItem, conIndex) in renderContent(listItem.nutrient)" :key="conIndex">{{ conItem }}</p>
                                <span>{{ listItem.nutrient ? '' : '无' }}</span>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { TAB_MAP_VALUE } from '../assets/js/constants';
import schoolAndDate from "./schoolAndDate.vue";
export default {
    props: {
        deptId: {
            type: String,
            default: ''
        },
        outletsId: {
            type: String,
            default: ''
        },
        dateTime: {
            type: String,
            default: '',
        },
        schoolName: {
            type: String,
            default: '',
        },
    },
    components: { schoolAndDate, },
    data() {
        return {
            infos: [],
            animationDuration: 0,
            colsNameArr: ['餐次', '营养食谱', '油盐用量', '主要营养'],
        }
    },
    mounted() {
        this.getListForYingyangsuList()
        setTimeout(() => {
            this.refreshPage()
        }, 1000)
    },
    methods: {

        // 获取餐次信息
        getListForYingyangsuList() {
            const param = {
                outletsId: this.outletsId,
                recipeType: 0
            }
            this.$get(this.$api.getListForYingyangsu, param).then(res => {
                console.log(`===>(item=13) ${TAB_MAP_VALUE['13']} <===`, res)
                this.infos = res.data
                this.refreshPage()
            })
        },

        handleInfoItemData(infoItem) {
            const getDataFn = (arrList) => {
                return {
                    cookBook: arrList.map(item => item.name).join('、'),
                    oilAndSaltAndSugar: arrList[0] ? arrList[0].oilAndSaltAndSugar : '',
                    nutrient: arrList[0] ? arrList[0].nutrient : '',
                }
            }
            // 第一行标题栏
            const colsNameObj = {
                title: this.colsNameArr[0],
                cookBook: this.colsNameArr[1],
                oilAndSaltAndSugar: this.colsNameArr[2],
                nutrient: this.colsNameArr[3],
            }
            try {
                const { breakfastList, lunchList, dinnerList, nightList } = infoItem
                const breakfastObj = {
                    title: '早餐',
                    ...getDataFn(breakfastList),
                }
                const lunchObj = {
                    title: '午餐',
                    ...getDataFn(lunchList),
                }
                const dinnerObj = {
                    title: '晚餐',
                    ...getDataFn(dinnerList),
                }
                const nightObj = {
                    title: '夜餐',
                    ...getDataFn(nightList),
                }
                return nightList.length ? [colsNameObj, breakfastObj, lunchObj, dinnerObj, nightObj] : [colsNameObj, breakfastObj, lunchObj, dinnerObj]
            } catch (error) {
                return colsNameObj
            }
        },

        renderContent(txt = '') {
            try {
                return txt.split(';')
            } catch (error) {
                return txt
            }
        },

        refreshPage() {
            this.$nextTick(() => {
                this.calcDocumentHeight()
            })
        },

        // 计算高度
        calcDocumentHeight() {
            if (this.$refs.content.offsetHeight > 960) {
                this.animationDuration = (this.$refs.content.offsetHeight / 200) * 5.5
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@keyframes scroll-up {
    0% {
        transform: translateY(vh(80));
        /* 文本初始位置，向上偏移 0 */
    }

    100% {
        transform: translateY(-100%);
        /* 文本最终位置，向上偏移 100%（等于滚动区域高度） */
    }
}

$fontColor: #0A7B23;
$borderColor: #59C06F;

.container {
    position: relative;
}

$wrapHeight: 830;

.wrap {
    height: vh($wrapHeight);
    width: 100%;
    overflow: hidden;
    border-radius: 3px;
    font-weight: bold;
    background: #b2f5c2;

    .meal-list-wrap {
        padding: vh(12) vh(18);
    }

    .meal-list {
        margin-bottom: vh(20);

        .meal-date {
            color: #000;
            text-align: left;
            font-size: vh(22);
            margin-bottom: vh(10);
        }

        .meal-block {
            overflow: hidden;
            color: $fontColor;
            border-radius: vh(10);
            border: 1px solid $borderColor;

            .meal-item {
                display: flex;
                font-size: vh(16);
                white-space: normal;
                text-align: left;
                border-bottom: 1px solid $borderColor;

                >.meal-title,
                >.meal-content {
                    border-left: 1px solid $borderColor;
                    padding: vh(10) vh(12);

                    &:first-of-type {
                        border-left: none;
                        text-align: center;
                        flex: 0.5;
                    }
                }

                &:last-of-type {
                    border-bottom: none;
                }

                .meal-title {
                    flex: 1;
                    font-size: vh(14);
                    text-align: center;
                    background: #8EDE9F;
                }

                .meal-content {
                    flex: 1;
                    word-wrap: break-word;

                    &:first-of-type {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }

                    span {
                        line-height: 1.2;
                    }
                }
            }
        }
    }
}

.overhide {
    overflow: hidden;
    height: vh($wrapHeight - 50);
}

.unified-meal {
    display: flex;
    flex-direction: column;
    min-height: 100%;
    width: 100%;
    animation-name: scroll-up;
    animation-duration: 0;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
}
</style>